module.exports = __webpack_public_path__ + "img/24.a7628de3.png";